import {
  DefaultModalDialog,
  InputField,
  Text,
} from '~/common/components/defaultUIComponents';
import EmployeeApi from '~/common/api/zeiterfassungServerApi/EmployeeApi';
import { EmployeeDepartments } from './EmployeeDepartments';
import { Stack, useToast } from '@chakra-ui/react';
import { useEmployeesContext } from './state';
import { useStore } from 'zustand';
import * as Yup from 'yup';
import * as yup from 'yup';
import React from 'react';

type AddEmployeeValues = {
  password: string;
  confirmPassword: string;
  firstname: string;
  lastname: string;
};

export const CreateAddEmployeeSchema = Yup.object().shape({
  password: Yup.string()
    .test({
      test: (v) => !v?.includes(' '),
      message: 'May not include spaces.',
    })
    .required('validator.required'),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref('password'), null],
    'validator.error.addEmployee.passwordsDoNotMatch',
  ),
  firstname: Yup.string().required('validator.required'),
  lastname: Yup.string().required('validator.required'),
  departments: yup
    .array()
    .of(yup.number().required('validator.required'))
    .required('validator.required')
    .min(1, 'validator.error.chooseOne'),
});

export const AddEmployeeModal: React.FC = () => {
  const employeesStore = useEmployeesContext();
  const { isOpen, onToggle } = useStore(employeesStore, (state) => ({
    isOpen: state.addEmployeeOpen,
    onToggle: state.toggleAddEmployeeOpen,
  }));

  const toast = useToast({ status: 'error', title: 'generic.error' });
  const { mutateAsync: addEmployee } = EmployeeApi.hooks.useAddEmployee();

  return (
    <DefaultModalDialog
      dialogHeaderText="employees.addEmployee.dialogHeaderText"
      submitText="employees.addEmployee.submitText"
      isOpen={isOpen}
      onCancel={onToggle}
      onSubmit={(values: AddEmployeeValues) => {
        addEmployee(values).then(onToggle).catch(toast);
      }}
      showCancelButton
      size="xl"
      initialValues={
        {
          password: '',
          confirmPassword: '',
          firstname: '',
          lastname: '',
          departments: [],
        } as AddEmployeeValues
      }
      validationSchema={CreateAddEmployeeSchema}
      validateOnChange
    >
      <Stack>
        <InputField
          name="password"
          type="password"
          label="employees.addEmployee.input.password.label"
          placeholder=""
          autoComplete="off"
          mb={1}
        />
        <InputField
          name="confirmPassword"
          type="password"
          label="employees.addEmployee.input.confirmPassword.label"
          placeholder=""
          autoComplete="off"
          mb={1}
        />
        <InputField
          name="firstname"
          type="text"
          label="employees.addEmployee.input.firstname.label"
          placeholder=""
          autoComplete="off"
          mb={1}
        />
        <InputField
          name="lastname"
          type="text"
          label="employees.addEmployee.input.lastname.label"
          placeholder=""
          autoComplete="off"
          mb={1}
        />
        <Text>employeeTile.editEmployee.departments</Text>
        <EmployeeDepartments name="departments" />
      </Stack>
    </DefaultModalDialog>
  );
};
